export const FORCE_AWAY_TOAST_DURATION = 8 * 3600 * 1000; // 8h
